/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Typography2, breakpoints } from '@coursera/cds-core';

const sizeStyles = {
  original: css`
    display: inline-flex;
    align-items: center;
    padding: 1px 5px;
    border-radius: 4px;
  `,
  thick: css`
    display: inline-flex;
    align-items: center;
    padding: var(--cds-spacing-50) var(--cds-spacing-150);
    border-radius: 4px;

    ${breakpoints.down('sm')} {
      padding: 1px var(--cds-spacing-100);
    }
  `,
};

// default, used by "Top Instructor" and "New AI skills"
const defaultColor = {
  backgroundColor: 'var(--cds-color-blue-100)',
  color: 'var(--cds-color-callouts-tertiary)',
};

const badgeTextStyle = css`
  font-weight: 600;
  white-space: nowrap;
`;

type Props = {
  designStyle?: 'original' | 'thick';
  color?: { backgroundColor: string; color: string };
};

function Badge({ children, designStyle = 'original', color = defaultColor }: React.PropsWithChildren<Props>) {
  const colorStyle = css`
    background-color: ${color.backgroundColor};
    color: ${color.color};
  `;

  return (
    <div css={[sizeStyles[designStyle], colorStyle]}>
      <Typography2 variant="subtitleMedium" component="div" color="inherit" css={badgeTextStyle}>
        {children}
      </Typography2>
    </div>
  );
}

export default Badge;
